export const URL = '/v2/pms/accomodations/:id/room_categories/reorder/'

export type Req = {
  ids: number[]
}

export type Resp = any